/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Faq_3_QInputs */

const en_landing_faq_3_q = /** @type {(inputs: Landing_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How does Alchema's AI governance and data security work?`)
};

const de_landing_faq_3_q = /** @type {(inputs: Landing_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie funktionieren KI-Governance und Datensicherheit bei Alchema?`)
};

const fr_landing_faq_3_q = /** @type {(inputs: Landing_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema est-il conforme au RGPD ?`)
};

const es_landing_faq_3_q = /** @type {(inputs: Landing_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es Alchema compatible con el RGPD?`)
};

const it_landing_faq_3_q = /** @type {(inputs: Landing_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema e conforme al GDPR?`)
};

const nl_landing_faq_3_q = /** @type {(inputs: Landing_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Alchema AVG-conform?`)
};

const pl_landing_faq_3_q = /** @type {(inputs: Landing_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czy Alchema jest zgodna z RODO?`)
};

const fi_landing_faq_3_q = /** @type {(inputs: Landing_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onko Alchema GDPR-yhteensopiva?`)
};

const da_landing_faq_3_q = /** @type {(inputs: Landing_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er Alchema GDPR-kompatibel?`)
};

const sv_landing_faq_3_q = /** @type {(inputs: Landing_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aer Alchema GDPR-kompatibelt?`)
};

/**
* | output |
* | --- |
* | "How does Alchema's AI governance and data security work?" |
*
* @param {Landing_Faq_3_QInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_faq_3_q = /** @type {((inputs?: Landing_Faq_3_QInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Faq_3_QInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_faq_3_q(inputs)
	if (locale === "fr") return fr_landing_faq_3_q(inputs)
	if (locale === "es") return es_landing_faq_3_q(inputs)
	if (locale === "it") return it_landing_faq_3_q(inputs)
	if (locale === "nl") return nl_landing_faq_3_q(inputs)
	if (locale === "pl") return pl_landing_faq_3_q(inputs)
	if (locale === "fi") return fi_landing_faq_3_q(inputs)
	if (locale === "da") return da_landing_faq_3_q(inputs)
	if (locale === "sv") return sv_landing_faq_3_q(inputs)
	return en_landing_faq_3_q(inputs)
});